// src/helpers/factories/settings/registerModeFactory.ts
var QSR_ACTION_ON_PAY_OPTIONS = [
  "logout" /* LOGOUT */,
  "new order" /* NEW_ORDER */,
  "view orders" /* VIEW_ORDERS */
];
var DEFAULT_ORDER_TYPE_OPTIONS = [
  "dine in" /* DINE_IN */,
  "to_go" /* TO_GO */
];
var TICKET_SEAT_BAR_OPTIONS = [
  "none" /* NONE */,
  "carousel" /* CAROUSEL */,
  "buttonsWithFilter" /* BUTTONS_WITH_FILTER */,
  "buttonsNoFilter" /* BUTTONS_NO_FILTER */
];
var SEAT_MANAGEMENT_BUTTON_FUNCTION_OPTIONS = [
  "seatTagsOnly" /* SEAT_TAGS_ONLY */,
  "allowPreselectSeats" /* ALLOW_PRESELECT_SEATS */
];
var registerModeQsrActionOnPayOptionsFactory = (t) => [
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.navigationOnAction.qsrActionOnPay.options.logout"
    ),
    value: QSR_ACTION_ON_PAY_OPTIONS.indexOf("logout" /* LOGOUT */) + 1
  },
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.navigationOnAction.qsrActionOnPay.options.newOrder"
    ),
    value: QSR_ACTION_ON_PAY_OPTIONS.indexOf("new order" /* NEW_ORDER */) + 1
  },
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.navigationOnAction.qsrActionOnPay.options.viewOrders"
    ),
    value: QSR_ACTION_ON_PAY_OPTIONS.indexOf("view orders" /* VIEW_ORDERS */) + 1
  }
];
var registerModeTicketSeatBarOptionsFactory = (t) => TICKET_SEAT_BAR_OPTIONS.map((option, index) => ({
  label: t(
    `settingsModule.registerModeSettings.tableService.general.seating.ticketSeatBar.options.${option}`
  ),
  value: index + 1
}));
var registerModeSeatManagementButtonFunctionOptionsFactory = (t) => SEAT_MANAGEMENT_BUTTON_FUNCTION_OPTIONS.map((option, index) => ({
  label: t(
    `settingsModule.registerModeSettings.tableService.general.seating.seatManagementButtonFunction.options.${option}`
  ),
  value: index + 1
}));
var registerModeSuggestedTioOptionsFactory = (t, numberOfTips = 3) => Array.from(Array(numberOfTips).keys()).map((_, index) => ({
  label: t(
    `settingsModule.onlineSettings.tips.suggestedTip${index + 1}`
  ),
  value: index + 1
}));
var registerModeDefaultOrderTypeFactory = (t) => [
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.navigationOnAction.defaultOrderType.options.dineIn"
    ),
    value: DEFAULT_ORDER_TYPE_OPTIONS.indexOf("dine in" /* DINE_IN */) + 1
  },
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.navigationOnAction.defaultOrderType.options.toGo"
    ),
    value: DEFAULT_ORDER_TYPE_OPTIONS.indexOf("to_go" /* TO_GO */) + 1
  }
];

export { DEFAULT_ORDER_TYPE_OPTIONS, QSR_ACTION_ON_PAY_OPTIONS, SEAT_MANAGEMENT_BUTTON_FUNCTION_OPTIONS, TICKET_SEAT_BAR_OPTIONS, registerModeDefaultOrderTypeFactory, registerModeQsrActionOnPayOptionsFactory, registerModeSeatManagementButtonFunctionOptionsFactory, registerModeSuggestedTioOptionsFactory, registerModeTicketSeatBarOptionsFactory };
